import './PageHero.css';

export default function PageHero({ icon, title }) {
  return (
    <div className="page-hero">
      <img
        src={icon}
        alt=""
        width="120"
        height="120"
        loading="lazy"
        className="page-hero-icon"
      />
      <h1 className="page-hero-title">{title}</h1>
    </div>
  );
}
